export * from "../address";
export * from "./banking-info.schema";
export * from "./social-media.schema";
export * from "./perfomance.schema";

import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";
import { PHONE_REGEX, TAX_ID_REGEX, ERROR_MESSAGES } from "constants/validation";

/**
 * Affiliate Schema
 * Base schema is loose to allow loading legacy data.
 */
export const AffiliateSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    email: Yup.string().nullable(),
    firstName: Yup.string().nullable(),
    lastName: Yup.string().nullable(),
    phoneNo: Yup.string().nullable(), 
    birthdate: Yup.date().nullable(),
    profilePicture: Yup.string().nullable(),
    status: Yup.string().nullable(),
    partnerType: Yup.string().nullable(),
    pdpaAccept: Yup.boolean().nullable(),
    companyName: Yup.string().nullable(),
    companyIndustry: Yup.string().nullable(),
    marketingChannel: Yup.array().of(Yup.string()).nullable(),
    taxNo: Yup.string()
      .nullable()
      .transform((val) => (val ? val.replace(/\D/g, "") : val)), 
    registerDate: Yup.date().nullable(),
    socialMediaPlatform: Yup.string().nullable(),
    // Timestamps
    updatedAt: Yup.date().nullable(),
    createdAt: Yup.date().nullable(),
  });

/**
 * Affiliate Validation Schema
 * Strict rules applied only during form submission.
 */
export const AffiliateValidationSchema = AffiliateSchema.clone().shape({
  email: Yup.string()
    .required(ERROR_MESSAGES.EMAIL_REQUIRED)
    .email(ERROR_MESSAGES.INVALID_EMAIL),
  firstName: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  lastName: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  status: Yup.string().oneOf(["Pending", "Approved", "Suspended", "Rejected"]).required(ERROR_MESSAGES.REQUIRED),
  partnerType: Yup.string().oneOf(["Individual", "Company"]).required(ERROR_MESSAGES.REQUIRED),
  phoneNo: Yup.string()
    .nullable()
    .matches(PHONE_REGEX, ERROR_MESSAGES.PHONE_FORMAT),
  taxNo: Yup.string()
    .nullable()
    .transform((val) => (val ? val.replace(/\D/g, "") : val))
    .matches(TAX_ID_REGEX, ERROR_MESSAGES.TAX_ID_FORMAT),
});

export const AffiliateReadSchema = AffiliateSchema.clone().shape({
  email: Yup.string()
    .transform((value) => (Yup.string().email().isValidSync(value) ? value : "invalid@email.com"))
    .email()
    .required(),
});
